(function () {
  'use strict';

  function all(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function init(root) {
    if (root.dataset.clTbBuyboxReady === 'true') return;
    root.dataset.clTbBuyboxReady = 'true';

    var variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-cl-variants]').textContent || '[]');
    } catch (error) {
      variants = [];
    }

    function findVariant(id) {
      return variants.find(function (variant) {
        return String(variant.id) === String(id);
      });
    }

    function syncOptionSelects(variant) {
      if (!variant || !variant.options) return;
      all('[data-cl-option-select]', root).forEach(function (select) {
        var index = Number(select.dataset.optionPosition) - 1;
        if (variant.options[index] !== undefined) select.value = variant.options[index];
      });
    }

    function syncThumbs(variant) {
      if (!variant) return;
      var media = variant.featured_media || variant.featured_image;
      var mediaId = media && media.id;
      if (!mediaId) return;
      all('[data-cl-thumb]', root).forEach(function (thumb) {
        thumb.classList.toggle('is-active', String(thumb.dataset.mediaId) === String(mediaId));
      });
    }

    function disableUnavailableCombination() {
      all('[data-cl-buy]', root).forEach(function (card) {
        card.dataset.clCombinationUnavailable = 'true';
        var variantId = card.querySelector('[data-cl-variant-id]');
        var submit = card.querySelector('[data-cl-submit]');
        var label = card.querySelector('[data-cl-submit-label]');
        if (variantId) variantId.value = '';
        if (submit) {
          submit.dataset.variantAvailable = 'false';
          submit.disabled = true;
        }
        if (label) {
          label.textContent = submit && submit.dataset.unavailableLabel
            ? submit.dataset.unavailableLabel
            : 'Unavailable';
        }
      });
    }

    function enableValidCombination() {
      all('[data-cl-buy]', root).forEach(function (card) {
        delete card.dataset.clCombinationUnavailable;
      });
    }

    function keepVialsShipDatesVisible() {
      if (root.dataset.clTemplate !== 'cl-tabbed-vials') return;

      function revealFilledDates() {
        all('[data-cl-shipdate]', root).forEach(function (shipDate) {
          if (shipDate.textContent.trim() && shipDate.hidden) shipDate.hidden = false;
        });
      }

      revealFilledDates();
      if (window.MutationObserver) {
        new MutationObserver(revealFilledDates).observe(root, {
          attributes: true,
          attributeFilter: ['hidden', 'data-cl-filled'],
          childList: true,
          subtree: true
        });
      }
    }

    all('[data-cl-option-select]', root).forEach(function (select) {
      select.addEventListener('change', function () {
        var card = select.closest('[data-cl-buy]');
        var optionSelects = all('[data-cl-option-select]', card);
        var selected = optionSelects.map(function (optionSelect) {
          return optionSelect.value;
        });
        var variant = variants.find(function (item) {
          return item.options && item.options.every(function (value, index) {
            return value === selected[index];
          });
        });
        var variantSelect = card.querySelector('[data-cl-variant-select]');
        if (!variant || !variantSelect) {
          disableUnavailableCombination();
          return;
        }
        enableValidCombination();
        variantSelect.value = variant.id;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        syncOptionSelects(variant);
        syncThumbs(variant);
      });
    });

    all('[data-cl-variant-select]', root).forEach(function (select) {
      select.addEventListener('change', function () {
        var variant = findVariant(select.value);
        if (variant) enableValidCombination();
        syncOptionSelects(variant);
        syncThumbs(variant);
      });
    });

    all('[data-cl-variant-button]', root).forEach(function (button) {
      button.addEventListener('click', function () {
        var variant = findVariant(button.dataset.variantId);
        if (variant) enableValidCombination();
        syncOptionSelects(variant);
        syncThumbs(variant);
      });
    });

    all('[data-cl-product-form]', root).forEach(function (form) {
      form.addEventListener('submit', function (event) {
        var card = form.closest('[data-cl-buy]');
        if (!card || card.dataset.clCombinationUnavailable !== 'true') return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);
    });

    var selected = root.querySelector('[data-cl-variant-id]');
    if (selected) {
      var currentVariant = findVariant(selected.value);
      syncOptionSelects(currentVariant);
      syncThumbs(currentVariant);
    }
    keepVialsShipDatesVisible();
  }

  function start() {
    all('[data-cl-buybox]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
